import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../../../core/user.service";
import { AlertService } from "../../../../_services/index";
import { CqmnsProjectPopupComponent } from "../../../../_models/cqmns-project-popup/cqmns-project-popup.component";
import {MatDialog, MatDialogConfig} from "@angular/material";
import { AuthService } from "../../../../core/auth/auth.service";

@Component({
  selector: 'app-cqmns-validate-defect',
  templateUrl: './cqmns-validate-defect.component.html',
  styleUrls: ['./cqmns-validate-defect.component.css']
})
export class CqmnsValidateDefectComponent implements OnInit {
  projectId: any;
  issues: any;
  // value1: string;
  // value2: string;
  autoassign: any;
  value1: any;
  value2: any;
  hostUrl;
  project:any;
  projectName:any;
  p;
  selectedIssues: any=[];
  userId: any;
  constructor(
    private alertService: AlertService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private matDialog: MatDialog, private authService: AuthService, 
  ) {}
  oldField = "";
  order = true;
  sortautoClassification = "fa fa-sort";
  sortissueID = "fa fa-sort";
  sortDescription = "fa fa-sort";
  sortautoAssign = "fa fa-sort";
  isDesc = false;
  message: any;
  source: any = [];
  count = 0;
  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
      this.userId = localStorage.getItem("userid");

    this.hostUrl = this.userService.getUrl();
  //  this.projectId = this.route.snapshot.params["projectId"];
    this.projectId = localStorage.getItem("projectId");
    this.projectName = localStorage.getItem("cqm-project-name");

    /* Get the list of all Un-approved Issues*/
    this.http
      .get(
        encodeURI(
          this.hostUrl + "/api/issue/bystatus/" + this.projectId + "/1/0"
        )
      )
      .subscribe(data => {
         this.issues = data
      });
    // this.http
    //   .get(
    //     encodeURI(
    //       this.hostUrl + "/api/issue/sourceClassification/" + this.projectId
    //     )
    //   )
    //   .subscribe(data => {
    //     this.message = data;
    //     for (let i = 0; i <= this.message.length; i++) {
    //       this.source = this.message[i].source;
    //     }
    //   });
    this.http
      .get(
        encodeURI(
          this.hostUrl + "/api/issue/activatedProjects/" + this.projectId
        )
      )
      .subscribe(data => {
        this.project = data;
        for (let i = 0; i <= this.project.length; i++) {
          if(this.project[i]){
        this.projectName = this.project[i].project_name;
          }
        }
      });
  }

  /* Updating the value on change */
  onchange1(value1) {
    this.value1 = value1;
    console.log(this.value1);
  }
  onchange2(value2) {
    this.value2 = value2;
    console.log(this.value2);
  }

  onDone() {
    const url = "/cqmns-approved-defect";
    this.router.navigate([url]);
  }
  onSubmit(id, autoclass) {
    let classi = "";
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    if (
      this.value1 === "" ||
      this.value1 === "Select" ||
      this.value1 === undefined
    ) {
      const updateBody = {
        classificationType: "0",
        ApprovalStatus: "1",
        approvedClassification: autoclass
      };
      this.http
        .post(
          encodeURI(this.hostUrl + "/api/issue/update/" + id.toString()),
          updateBody,
          { headers: headers }
        )
        .subscribe(data => {
          for (let i = 0; i < this.issues.length; i++) {
            if (this.issues[i].ISSUEID === id) {
              this.issues.splice(i, 1);
            }
          }
        });
    } else {
      let updateBody = {};
      updateBody = {
        classificationType: "1",
        ApprovalStatus: "1",
        approvedClassification: this.value1
      };
      this.http
        .post(
          encodeURI(this.hostUrl + "/api/issue/update/" + id.toString()),
          updateBody,
          { headers: headers }
        )
        .subscribe(data => {
          for (let i = 0; i < this.issues.length; i++) {
            if (this.issues[i].ISSUEID === id) {
              classi += this.issues[i].AUTOCLASSIFICATION;
              this.issues.splice(i, 1);
            }
          }

          this.http
            .post(
              encodeURI(
                this.hostUrl +
                  "/api/jira/changeLabel/" +
                  id.toString() +
                  "/" +
                  classi.toString()
              ),
              updateBody,
              { headers: headers }
            )
            .subscribe();
        });
    }
    this.value1 = "Select";
  }

  checkAll(event) {
    const checked = event.target.checked;
    if (checked) {
      this.issues.forEach(element => {
        element.checked = true;            
        this.selectedIssues.push(element);
      });
    } else {
      this.issues.forEach(element => {
        element.checked = false;
        this.selectedIssues = [];
      });
    }
    console.log(this.selectedIssues)
}

issueSelect(issue, event) {
  console.log(event.target.checked);
  const checked = event.target.checked; 
  if (checked) {
    const demoObj = {};
    demoObj['ISSUEID'] = issue.ISSUEID;  
    demoObj['AUTOCLASSIFICATION'] = issue.AUTOCLASSIFICATION;
    demoObj['AUTOASSIGN'] = issue.AUTOASSIGN;      
    var elementPos = this.issues.map(function (x) { return x.ISSUEID; }).indexOf(issue.ISSUEID);
    this.issues[elementPos].checked = true;
    this.selectedIssues.push(demoObj);
  } else {
    const index = this.selectedIssues.findIndex(list => list.id == issue.id); //Find the index of stored id
    this.selectedIssues.splice(index, 1); // Then remove
    var elementPos = this.issues.map(function (x) { return x.ISSUEID; }).indexOf(issue.ISSUEID);
    this.issues[elementPos].checked = false;
  }
  console.log('selected',this.selectedIssues);   
}
  approveAll() {
    for (const issue of this.selectedIssues) {
        let assign1 = "";
        let classi = "";
        let headers = new HttpHeaders();
        headers = headers.append("Content-Type", "application/json");
          const updateBody = {
            assigntoType: "0",
            ApprovalStatusAssign: "1",
            approvedAssign: issue.AUTOASSIGN
          };
          this.http
            .post(
              encodeURI(this.hostUrl + "/api/issue/update/" + issue.ISSUEID.toString()),
              updateBody,
              { headers: headers }
            )
            .subscribe(data => {
              for (let i = 0; i < this.issues.length; i++) {
                if (this.issues[i].ISSUEID === issue.ISSUEID) {
                  this.issues.splice(i, 1);
                }
              }
            });
            const updateBodycls = {
              classificationType: "0",
              ApprovalStatus: "1",
              approvedClassification: issue.AUTOCLASSIFICATION
            };
            this.http
              .post(
                encodeURI(this.hostUrl + "/api/issue/update/" + issue.ISSUEID.toString()),
                updateBodycls,
                { headers: headers }
              )
              .subscribe(data => {
                for (let i = 0; i < this.issues.length; i++) {
                  if (this.issues[i].ISSUEID === issue.ISSUEID) {
                    this.issues.splice(i, 1);
                  }
                }
                if(this.issues.length == 0){
                  this.onDone();
                }
              });
              
    }
    
  //  this.onDone();
}

  //for assign approval
  onSubmit1(id, autoassign) {
    let assign1 = "";
    let headers = new HttpHeaders();
    console.log("inside null text", this.value2);
    headers = headers.append("Content-Type", "application/json");
    if (
      this.value2 === "" ||
      this.value2 === "Select" ||
      this.value2 === undefined
    ) {
      console.log("inside null text", this.value2);

      const updateBody = {
        assigntoType: "0",
        ApprovalStatusAssign: "1",
        approvedAssign: autoassign
      };
      this.http
        .post(
          encodeURI(this.hostUrl + "/api/issue/update/" + id.toString()),
          updateBody,
          { headers: headers }
        )
        .subscribe(data => {
          for (let i = 0; i < this.issues.length; i++) {
            if (this.issues[i].ISSUEID === id) {
              this.issues.splice(i, 1);
            }
          }
        });
    } else {
      let updateBody = {};
      updateBody = {
        assigntoType: "1",
        ApprovalStatusAssign: "1",
        approvedAssign: this.value2
      };
      this.http
        .post(
          encodeURI(this.hostUrl + "/api/issue/update/" + id.toString()),
          updateBody,
          { headers: headers }
        )
        .subscribe(data => {
          for (let i = 0; i < this.issues.length; i++) {
            if (this.issues[i].ISSUEID === id) {
              assign1 += this.issues[i].AUTOASSIGN;
              this.issues.splice(i, 1);
            }
          }

          this.http
            .post(
              encodeURI(
                this.hostUrl +
                  "/api/jira/changeLabel/" +
                  id.toString() +
                  "/" +
                  assign1.toString()
              ),
              updateBody,
              { headers: headers }
            )
            .subscribe();
        });
    }
    this.value2 = "Select";
  }

  approve(id, autoassign, autoclass) {
    this.onSubmit1(id, autoassign);

    this.onSubmit(id, autoclass);
  }
  sortBy(field) {
    if (this.oldField == field) {
      this.isDesc = !this.isDesc;
      this.order = !this.order;
    } else {
      this.isDesc = false;
      this.order = false;
      this.oldField = field;
    }
    if (this.order) {
      field = "-" + field;
    }
    if (field === "issueID" || field === "-issueID") {
      this.sortissueID = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortDescription = "fa fa-sort";
      this.sortautoClassification = "fa fa-sort";
      this.sortautoAssign = "fa fa-sort";
    } else if (field === "Description" || field === "-Description") {
      this.sortDescription = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortissueID = "fa fa-sort";
      this.sortautoClassification = "fa fa-sort";
      this.sortautoAssign = "fa fa-sort";
    } else if (field === " Classification" || field === "-Classification") {
      this.sortautoClassification = this.isDesc
        ? "fa fa-sort-desc"
        : "fa fa-sort-asc";
      this.sortissueID = "fa fa-sort";
      this.sortDescription = "fa fa-sort";
      this.sortautoAssign = "fa fa-sort";
    } else if (field === "Assigned To" || field === "-Assigned To") {
      this.sortautoAssign = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortissueID = "fa fa-sort";
      this.sortDescription = "fa fa-sort";
      this.sortautoClassification = "fa fa-sort";
    }
    this.issues = this.issues.sort(this.userService.dynamicSort(field));
  }
  projectPopup() {
    

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.panelClass = "login-modalbox";

    dialogConfig.backdropClass = 'popupBackdropClass';

    dialogConfig.maxHeight = window.innerHeight - 20 + 'px' ; 

    dialogConfig.panelClass = "ns-modalbox";
    dialogConfig.disableClose = false;
    this.matDialog.open(CqmnsProjectPopupComponent, dialogConfig);

}
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-actions/cqmns-validate-defect/cqmns-validate-defect.component.ts